import { render, staticRenderFns } from "./UserProfilesTableEdit.vue?vue&type=template&id=8fcabaf6&"
import script from "./UserProfilesTableEdit.vue?vue&type=script&lang=ts&"
export * from "./UserProfilesTableEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports